import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonComponent, HeadlineComponent, TextComponent } from '@zeiss/beyond-online-angular';
import { IconComponent } from 'vis-ods-angular';

@Component({
	selector: 'app-general-success-message',
	templateUrl: './general-success-message.component.html',
	imports: [TranslocoModule, IconComponent, HeadlineComponent, ButtonComponent, TextComponent],
})
export class GeneralSuccessMessageComponent {
	title: string = 'generalComponents.addedToCardPopUpSuccess.headlines.title';
	subtitle: string = '';
	text: string = 'generalComponents.addedToCardPopUpSuccess.texts.question';
	firstButtonText: string = 'generalComponents.addedToCardPopUpSuccess.buttons.home';
	secondButtonText: string = 'generalComponents.addedToCardPopUpSuccess.buttons.order';
	goToOrder() {}
	async goToHome() {}
	async goToCart() {}
}
